<template>
  <v-card color="#f0f8f6" class="overflow-hidden rounded-xl">
    <div class="text-right ma-3">
      <v-btn icon @click="$emit('cancel')">
        <v-icon large>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-row justify="center" align="center" class="pb-5">
      <v-col cols="16" class="text-center text-h4">
        <div>Назначить или отменить</div>
        <div>просмотр продукта</div>
      </v-col>
    </v-row>
    <v-card-text>
      <v-card elevation="0" class="rounded-xl" id="tree">
        <v-treeview
          :items="this.subCategories"
          :load-children="loadChildren"
          activatable
        >
          <template slot="label" slot-scope="{ item }">
            <div v-if="item.kinescope_id">
              <v-list>
                <v-list-item
                  v-for="p in [item].filter((i) => i.kinescope_id)"
                  :key="p.id"
                  class="px-0"
                >
                  <v-list-item-content style="max-width: 200px">
                    <v-list-item-title class="text-body-2">
                      {{ `[${p.type}] Сессия №${p.session_number}` }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
            <div v-else class="d-flex align-center">
              {{ item.name }}
              <v-simple-checkbox
                class="ml-5"
                :value="selected_category && selected_category === item.id"
                @input="doSelectCategory(item.id)"
              />
            </div>
          </template>
        </v-treeview>
      </v-card>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn
        class="white--text"
        style="
          background-color: #d86568;
          width: 150px;
          height: 50px;
          border-radius: 50px;
        "
        @click="$emit('confirm', selected_category)"
        :disabled="selected_category === null"
      >
        Назначить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SelectProductsForm",
  components: {},
  data() {
    return {
      selected_category: null,
      renderedNodes: [],
      subCategories: [],
    };
  },
  computed: {
    ...mapGetters("products", ["products"]),
    ...mapGetters("modals", ["modalFormComponent"]),
    ...mapGetters("categories", ["categories"]),
    title() {
      return this.modalFormComponent?.title;
    },
    desc() {
      return this.modalFormComponent?.desc;
    },
  },
  async mounted() {
    await this.request_categories();
    this.subCategories = this.categories
      .filter((category) => category.parent_id !== null)
      .map((category) => ({
        ...category,
        children: [],
      }));
  },
  methods: {
    ...mapActions("categories", ["request_categories"]),
    loadChildren(item) {
      this.addProductsToCategory(item);
      console.log(item);
    },
    addProductsToCategory(category) {
      // Фильтрация по id категории и типу продукта
      // Сортировка по номеру сессии в порядке возрастания
      const PCProducts = this.products
        .filter(
          (product) =>
            product.category_id === category.id && product.product_type === "PC"
        )
        .sort((a, b) => a.session_number - b.session_number)
        .map((product) => ({ ...product, type: "PC" }));
      const VRProducts = this.products
        .filter(
          (product) =>
            product.category_id === category.id && product.product_type === "VR"
        )
        .sort((a, b) => a.session_number - b.session_number)
        .map((product) => ({ ...product, type: "VR" }));
      const MGProducts = this.products
        .filter(
          (product) =>
            product.category_id === category.id && product.product_type === "MG"
        )
        .sort((a, b) => a.session_number - b.session_number)
        .map((product) => ({ ...product, type: "MG" }));

      // Добавление продуктов в подкатегории
      category.children = [...PCProducts, ...VRProducts, ...MGProducts];
    },
    doSelectCategory(item) {
      if (this.selected_category && this.selected_category === item) {
        this.selected_category = null; // снимаем выбор при повторном нажатии
      } else {
        this.selected_category = item;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.v-treeview {
  width: max-content;
}
@import "~vuetify/src/styles/styles.sass";

@media #{map-get($display-breakpoints, 'xs-only')} {
  .v-card #tree {
    overflow-x: scroll;
  }
}
</style>

<style lang="scss">
.v-list-group__header__append-icon {
  order: -1;
  margin-left: -25px !important;
  margin-right: 5px !important;
}
</style>
